import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800">
      <div className="container mx-auto px-4 py-12">
        <Link 
          to="/"
          className="inline-flex items-center text-gray-300 hover:text-white mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-8">
          <h1 className="text-3xl font-bold text-white mb-8">Privacy Policy</h1>
          
          <div className="prose prose-invert max-w-none text-white">
            <p className="text-sm text-gray-300 mb-6">Last updated: {new Date().toLocaleDateString()}</p>

            {/* Table of Contents */}
            <div className="bg-gray-900/30 p-6 rounded-lg mb-8">
              <h2 className="text-xl font-semibold mb-4">Table of Contents</h2>
              <ol className="list-decimal list-inside space-y-2">
                <li><a href="#information-collect" className="hover:text-primary">Information We Collect</a></li>
                <li><a href="#information-use" className="hover:text-primary">How We Use Your Information</a></li>
                <li><a href="#information-sharing" className="hover:text-primary">Information Sharing</a></li>
                <li><a href="#data-security" className="hover:text-primary">Data Security</a></li>
                <li><a href="#your-rights" className="hover:text-primary">Your Rights</a></li>
                <li><a href="#contact-us" className="hover:text-primary">Contact Us</a></li>
              </ol>
            </div>
            
            <section id="information-collect" className="mb-8">
              <h2 className="text-2xl font-bold mb-4">1. Information We Collect</h2>
              <p className="mb-4">We collect information you provide directly to us when you:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Create an account</li>
                <li>Create or modify a registry</li>
                <li>Make a purchase or contribution</li>
                <li>Contact us for support</li>
              </ul>
            </section>

            <section id="information-use" className="mb-8">
              <h2 className="text-2xl font-bold mb-4">2. How We Use Your Information</h2>
              <p className="mb-4">We use the information we collect to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Provide and maintain our services</li>
                <li>Process your transactions</li>
                <li>Send you notifications and updates</li>
                <li>Improve our services</li>
              </ul>
            </section>

            <section id="information-sharing" className="mb-8">
              <h2 className="text-2xl font-bold mb-4">3. Information Sharing</h2>
              <p className="mb-4">We do not sell or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>With your consent</li>
                <li>To comply with legal obligations</li>
                <li>To protect our rights and safety</li>
              </ul>
            </section>

            <section id="data-security" className="mb-8">
              <h2 className="text-2xl font-bold mb-4">4. Data Security</h2>
              <p className="mb-4">We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.</p>
            </section>

            <section id="your-rights" className="mb-8">
              <h2 className="text-2xl font-bold mb-4">5. Your Rights</h2>
              <p className="mb-4">You have the right to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Access your personal information</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Opt-out of marketing communications</li>
              </ul>
            </section>

            <section id="contact-us" className="mb-8">
              <h2 className="text-2xl font-bold mb-4">6. Contact Us</h2>
              <p className="mb-2">If you have questions about this Privacy Policy, please contact us at:</p>
              <p className="mb-1"><strong>Email:</strong> privacy@giftyfy.com</p>
              <p><strong>Phone:</strong> +94 779257975</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}